'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TranslatorProvider = require('./TranslatorProvider');

Object.defineProperty(exports, 'TranslatorProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TranslatorProvider).default;
  }
});

var _withTranslator = require('./withTranslator');

Object.defineProperty(exports, 'withTranslator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withTranslator).default;
  }
});

var _createTranslator = require('./createTranslator');

Object.defineProperty(exports, 'createTranslator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createTranslator).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-translations/dist/main/index.js
// module id = 70
// module chunks = 0